module.exports = __webpack_public_path__ + "static/media/card_small_2.d5f1405b.svg";